import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import MaterialThumbnail from 'components/consumer/MaterialThumbnail';
import BrandTooltip from 'components/consumer/BrandTooltip';
import useScreen from 'hooks/useScreen';
const PDPShownInUI = ({
  displayedUpholsteryLabel,
  fullWidth = false,
  layout,
  materialDetails,
  productName = null,
  rating,
  reviews,
  setUpholstery,
  showInactiveTooltip,
  showInactiveUpholstery,
  upholsteryOptionTypeId
}) => {
  const {
    isMobile,
    isMobileOrTablet
  } = useScreen();
  const containerRef = useRef(null);
  const materialLinkRef = useRef(null);
  const [isFlyoutVisible, setIsFlyOutVisible] = useState(false);
  const newTop = containerRef?.current?.getBoundingClientRect().top || 0;
  return displayedUpholsteryLabel ?
  // We have to use a div instead of a button here because another button may
  // be nested within this element, and buttons cannot be nested in HTML.
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div className={classNames('text-xs items-center text-gray flex', '[&>*+*]:max-[1023px]:ml-1', {
    'w-full': fullWidth,
    '!bg-gray-light7 rounded-[10px] px-2 py-[.1rem]': layout === 'greyBG',
    'justify-center': layout !== 'roundSwatchLabel',
    'justify-start absolute top-4 left-2.5 !bg-white rounded-[10px] px-2 py-[.1rem]': layout === 'roundSwatchLabel'
  })} onClick={setUpholstery}>
      {isFlyoutVisible && <FlyoutContainer top={newTop} imageUrl={materialDetails.image} content={materialDetails.description} title={displayedUpholsteryLabel} subTitle={reviews ? <RatingAndReviews rating={rating} numberOfReviews={reviews?.length} /> : null} onClose={() => setIsFlyOutVisible(false)} isOpen={isFlyoutVisible} showAboveOnDesktop />}

      {materialDetails ? <div className={classNames('relative ml-0 mr-[.35rem]', {
      'h-10 w-10': layout !== 'roundSwatchLabel',
      'h-[25px] w-[25px]': layout === 'roundSwatchLabel'
    })} ref={containerRef}>
          <MaterialThumbnail image={materialDetails.image} label={displayedUpholsteryLabel} materialId={materialDetails.id} onClick={setUpholstery} onHover={() => setIsFlyOutVisible(true)} upholsteryOptionId={upholsteryOptionTypeId} toggleFlyOut={() => setIsFlyOutVisible(false)} variant={layout === 'greyBG' ? 'PDPShownInUI--grey-background' : 'PDPShownInUI'} />
        </div> : null}

      <div ref={materialLinkRef}>
        {productName && !showInactiveUpholstery ? <span>{productName}</span> : <>
            <span>Shown in&nbsp;</span>

            {showInactiveTooltip && <BrandTooltip parentRef={materialLinkRef} showInfoIcon={false} title="" direction={isMobile || isMobileOrTablet ? 'bottom' : 'top'} isOpenDefault={showInactiveTooltip} showCloseButton={isMobile} variant="PDPShownInUI">{`The ${productName} is no longer available in ${displayedUpholsteryLabel}.`}</BrandTooltip>}

            <button type="button" onClick={setUpholstery} title={`Select ${displayedUpholsteryLabel}`} aria-label={`Select ${displayedUpholsteryLabel}`} className={classNames('text-xs bg-transparent border-0 text-brand font-bold hover:lg:cursor-pointer hover:lg:underline focus-visible:underline', {
          'text-gray': showInactiveUpholstery && showInactiveTooltip && isMobile
        })}>
              {displayedUpholsteryLabel}
            </button>
          </>}
      </div>
    </div> : null;
};
PDPShownInUI.propTypes = {
  displayedUpholsteryLabel: PropTypes.string,
  fullWidth: PropTypes.bool,
  layout: PropTypes.oneOf(['horizontal', 'vertical', 'roundSwatchLabel']),
  materialDetails: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    id: PropTypes.number
  }),
  productName: PropTypes.string,
  rating: PropTypes.number,
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  setUpholstery: PropTypes.func,
  showInactiveTooltip: PropTypes.bool,
  showInactiveUpholstery: PropTypes.bool,
  upholsteryOptionTypeId: PropTypes.number
};
export default PDPShownInUI;